import Navbar from './Navbar';

export default function Header() {
  return (
    <header className="main-header">
      <div className="container">
        <Navbar />
      </div>
    </header>
  );
}